import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';
import { OrganizationService } from 'src/app/services/organizationservice';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ReportRegistryService } from 'src/app/services/report/report-registry.service';
import { SignupLoginService } from 'src/app/services/signupLogin.service';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-main-filter',
  templateUrl: './main-filter.component.html',
  styleUrls: ['./main-filter.component.css']
})
export class MainFilterComponent implements OnInit {

  salespersons: any;
  selected_salespersons: any = [];
  seleted_teams: any = [];
  teams: any;
  salespersonTeamIDs = [];
  salespersonsIDs = [];
  private userId: number;
  private user;
  selectedType = 'salespersons';

  salesperson_config = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Select Salesperson", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search salesperson",
    displayKey: 'fullName',
  };
  salep_setconfig = {
    "itemsShowLimit": 1,
    "singleSelection": false,
    "idField": "id",
    "textField": "fullName",
    "selectAllText": "All Salesperson",
    "unSelectAllText": "All Salesperson",
  }
  teams_setconfig = {
    "itemsShowLimit": 1,
    "singleSelection": false,
    "idField": "teamID",
    "textField": "teamName",
    "selectAllText": "All Teams",
    "unSelectAllText": "All Teams",
  }

  team_config = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Select Teams", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search team",
    displayKey: 'teamName',
  };

  constructor(
    private organisation_service: OrganizationService,
    private signup_service: SignupLoginService,
    private report_registry: ReportRegistryService,
    private reports_service: PerformanceReportService,
    private store: Store<AppState>,
  ) {
    this.store.select('userInfo').subscribe(info => {
      this.userId = info.user.id;
      this.user = info.user;
    });
  }

  ngOnInit() {
    const names = { [this.userId]: { name: `${this.user.firstName} ${this.user.lastName}`, ...this.user } }
    this.reports_service.selected_users.next({ ids: [this.userId], type: 'salesperson', names });
    const getTeams = this.signup_service.fetchSupervisorTeams().pipe(map(allTeams => {
      const teams = allTeams.filter(t => t.teamID !== 'All');
      teams.forEach(team =>
        team.teamID !== "All" ? this.salespersonTeamIDs.push(team.teamID) : null
      )
      return teams;
    }
    ));
    const getSurbodinates = this.signup_service.fetchSubordinatesSalesperson(this.user.email).pipe(map(subs => {
      const result = subs.concat(this.user);
      this.salespersonsIDs = result.map(sub => (sub.id));
      return result.map(sub => ({ ...sub, fullName: `${sub.firstName} ${sub.lastName}` }))
    }));
    //
    forkJoin([
      getTeams,
      getSurbodinates
    ]).subscribe(responses => {
      this.teams = responses[0];
      this.salespersons = [...responses[1]];
      this.selected_salespersons = responses[1].filter(salesperson => salesperson.id == this.userId);
    });
  }
  changeType = (type) => {
    this.selected_salespersons = this.salespersons.filter(salesperson => salesperson.id == this.userId);
    this.seleted_teams = this.teams.filter(team => team.teamID == this.user.teamID);
    this.selectedType = type;
    if (type === 'teams') {
      this.selectTeam(this.seleted_teams)
    } else {
      this.selectSalesperson(this.selected_salespersons)
    }
  };

  selectSalesperson(value: any[]) {
    let names = {};
    let ids = [];

    value.forEach(val => {
      ids.push(val.id);
      names[val.id] = { name: val.fullName };
    });
    this.reports_service.selected_users.next({ ids, type: 'salesperson', names });
  }

  selectTeam(value) {
    let names = {};
    let ids = [];
    value.forEach(val => {
      ids.push(val.teamID);
      names[val.teamID] = { name: val.teamName };
    });
    this.reports_service.selected_users.next({ ids, type: 'team', names });
  }
}
